import type { EpcPreviewRow } from "features/dt-basic-setup/single-building/lib/epcPreviewRows";

import { Stack } from "@mui/material";
import { LabelValueInline } from "components/LabelValueInline";

export const EpcDataRow = ({ row }: { row: EpcPreviewRow }) => {
  if (row.variant === "groupHeader") {
    return <p className="text-lds-foreground-heading font-ds-headline-xs pb-1 pt-3">{row.label}</p>;
  }
  return (
    <Stack
      className={`w-full py-1 border-b-ds-soft ${row.variant === "nested" ? "ml-3 border-0 border-l-ds-soft" : ""}`}
    >
      <LabelValueInline
        className={row.variant === "nested" && "pl-3"}
        label={row.label}
        labelProps={{ className: "shrink-0 flex-end w-[30rem]" }}
        value={row.value}
        valueProps={{}}
      />
    </Stack>
  );
};
